import CommonMomentAndAttendance from '../commonfile/CommonMomentAndAttendance'

const CoordinatorMomentAttendance = () => {
    return (
        <>
            <CommonMomentAndAttendance />
        </>
    )
}

export default CoordinatorMomentAttendance